import { render, staticRenderFns } from "./PublicShareEvent.vue?vue&type=template&id=2a819306"
import script from "./PublicShareEvent.vue?vue&type=script&lang=js"
export * from "./PublicShareEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports